import { render, staticRenderFns } from "./Brm.vue?vue&type=template&id=243c5f18"
import script from "./Brm.vue?vue&type=script&lang=js"
export * from "./Brm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports